import Button from "./Button";
import Spinner from "../spinner/Spinner";
import TranslatableText from "../translations/TranslatableText";
import { BiPlay } from "react-icons/bi";
import { FiLogOut } from "react-icons/fi";
import { CSSProperties } from "react";
import { useIconSize } from "@app/hooks";

interface FormActionButtonsProps {
  isSubmitting?: boolean;
  isValid?: boolean;
  onSubmitClick?: () => void;
  onLogoutClick?: () => void;
  submitBorderColor?: string; // fallback to theme color if not provided
  submitBgColor?: string;
  logoutBorderColor?: string;
  className?: string;
  style?: CSSProperties;
}

const FormActionButtons = ({
  isSubmitting = false,
  isValid = true,
  onSubmitClick,
  onLogoutClick,
  submitBorderColor = "var(--quaternary-deep)",
  submitBgColor = "var(--quaternary-bright)",
  logoutBorderColor = "#999999",
  className,
  style,
}: FormActionButtonsProps) => {
  const iconSize = useIconSize(20);

  // Common button classes ensure consistent layout, truncation and no overflow
  const baseBtn = `btn-save form-actions-btn ${className ?? ""}`;

  return (
    <div className="w-100 d-flex justify-content-between" style={style}>
      <Button
        type="submit"
        className={baseBtn}
        disabled={isSubmitting || !isValid}
        onClick={onSubmitClick}
        style={{ border: `1px solid ${submitBorderColor}` }}
      >
        <div
          className="save-icon p-1"
          style={{ backgroundColor: submitBgColor, opacity: isValid ? 1 : 0.8 }}
        >
          {isSubmitting ? <Spinner size={20} /> : <BiPlay size={iconSize} color="var(--white)" />}
        </div>
        <span className="label ff-medium no-wrap truncate" title="">
          <TranslatableText translationKey="main.update_changes" />
        </span>
      </Button>

      <Button
        className={baseBtn}
        onClick={onLogoutClick}
        style={{ border: `1px solid ${logoutBorderColor}` }}
      >
        <div className="save-icon p-1">
          <FiLogOut size={iconSize} color="#5D5555" />
        </div>
        <span className="label" style={{ color: "rgba(93, 85, 85, 0.75)" }}>
          <TranslatableText translationKey="main.logout" />
        </span>
      </Button>
    </div>
  );
};

export default FormActionButtons;


